import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=2d38ce59&scoped=true"
import script from "./doctorList.vue?vue&type=script&lang=js"
export * from "./doctorList.vue?vue&type=script&lang=js"
import style0 from "./doctorList.vue?vue&type=style&index=0&id=2d38ce59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d38ce59",
  null
  
)

export default component.exports